import * as React from 'react';

interface EditableTableResult {
  activeId: string | null;
  setActiveId: (value: string | null) => void;
}

const context = React.createContext<EditableTableResult>({
  activeId: null,
  setActiveId() {},
});

const { Provider } = context;

interface EditableTableProviderProps {
  children: React.ReactNode;
}

export function EditableTableProvider(props: EditableTableProviderProps) {
  const [activeId, setState] = React.useState<string | null>(null);
  const setActiveId = React.useCallback(
    async (value: string | null) => setState(value),
    [],
  );

  return (
    <Provider value={{ activeId, setActiveId }}>{props.children}</Provider>
  );
}

export function useEditableTable() {
  return React.useContext(context);
}
